import React, { useRef, useState, useEffect } from "react";
import { Button, Flex, Input, Modal } from "antd";
import { CheckCircleSolidIcon, GlobeCircleSolidIcon, LockCircleSolidIcon } from "./../../../assets/icons";
import TextArea from "antd/es/input/TextArea";
import ApiService from "../../../API/apiService";
import { API_ENDPOINTS } from "../../../API/endpoints";
import { useNavigate } from "react-router-dom";

const CreateChannelModal = ({isOpen, onClose, getChannelListApi}) => {

  const [isCreateChannelModalOpen, setIsCreateChannelModalOpen] = useState(false);
  const [channelName, setChannelName] = useState("");
  const [selectedChannel, setSelectedChannel] = useState("Private");
  const [channelNameErrMessage, setChannelNameErrMessage] = useState("");
  const [channelNameErr, setChannelNameErr] = useState(false);
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const UserData = JSON.parse(localStorage.getItem("userData"));
  const [loading, setLoading] = useState(false);
  
  let rout=UserData?.domain || 'elsnertech'

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);


  const handleCreateChannel = async () => {
    const reqBody = {
      channelName: channelName,
      isPrivate: selectedChannel === "Private",
      description: "",
    };
    setLoading(true);
    try {
      const response = await ApiService.post(
        API_ENDPOINTS.channelManage,
        reqBody
    );
      if (response?.data && response?.statusCode === 201) {
        setIsCreateChannelModalOpen(false);
        setChannelName("");
        setSelectedChannel("Private");
        // navigate(`/elsnertech/channels/${response?.data?._id}`);
    navigate(`/${rout}/channels/${response?.data?._id}`);

        getChannelListApi();
        onClose();
      } 
    } catch (error) {

       if (error?.status === 403) {
        setChannelNameErr(true)
        setChannelNameErrMessage(error?.response?.data?.message);
      }else{
        setChannelNameErr(true)

        setChannelNameErrMessage(error?.response?.data?.message);

      }
    }finally {
      setLoading(false);
    }
  };

  const handleChannelName = (e) => {
  const value = e.target.value;
  setChannelNameErrMessage("");
  if (value.trim().length <= 60) {
    setChannelName(value);
    setChannelNameErr(false);
  } else {
    setChannelNameErr(true);
    setChannelNameErrMessage("Channel name should not exceed 60 characters");
  }
};

  const handleChannelTypeSelection = (type) => {
    setSelectedChannel(type);
  };

  const handleCancel = async () => {
    setChannelName("");
    onClose();
    setSelectedChannel("Private");
  }

  return (
    <Modal
      destroyOnClose
      title="Create a new channel"
      className="ec-modal create-new-channel-modal"
      open={isOpen}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel} className="text-btn">
          Cancel
        </Button>,
        <Button
          key="create"
          type="primary"
          onClick={handleCreateChannel}
          className="primary-btn"
          disabled={channelName.trim().length <= 0 || channelNameErr}
        >
          Create Channel
        </Button>,
      ]}
      width={600}
      style={{ top: 20 }}
    >
      
      <Flex gap="2px" vertical className="ant-modal-subheader">
        <p className="input-label">Channel Name :</p>
        <Input placeholder="Channel Name" ref={inputRef} onChange={handleChannelName} />
        {channelNameErr && <span style={{ color: "red" }}>{channelNameErrMessage}</span>}
      </Flex>
      <Flex gap="small" className="public-private-selector">
        <Button
          type="text"
          className={`private-btn ${selectedChannel === "Public" ? "active" : ""}`}
          onClick={() => handleChannelTypeSelection("Public")}
          disabled={UserData?.roleName !== "Admin"}
        >
          <Flex justify="flex-start" align="center" gap="middle" className="btn-inner-wrapper">
            <span className="btn-icon">
              <GlobeCircleSolidIcon />
            </span>
            <Flex gap="4px" vertical className="btn-text">
              <span className="title">Public Channel</span>
              <span className="description">Anyone can join</span>
            </Flex>
            {selectedChannel === "Public" && (
              <span className="btn-icon">
                <CheckCircleSolidIcon />
              </span>
            )}
          </Flex>
        </Button>
        <Button
          className={`private-btn ${selectedChannel === "Private" ? "active" : ""}`}
          onClick={() => handleChannelTypeSelection("Private")}
          type="text"
        >
          <Flex justify="flex-start" align="center" gap="middle" className="btn-inner-wrapper">
            <span className="btn-icon">
              <LockCircleSolidIcon />
            </span>
            <Flex gap="4px" vertical className="btn-text">
              <span className="title">Private Channel</span>
              <span className="description">Only invited people can join</span>
            </Flex>
            {selectedChannel === "Private" && (
              <span className="btn-icon">
                <CheckCircleSolidIcon />
              </span>
            )}
          </Flex>
        </Button>
      </Flex>
      <Flex vertical>
        <TextArea
          placeholder="Enter a purpose for this channel (optional)"
          style={{ height: 120, resize: "none" }}
        />
        <p className="new-channel-modal-purpose-info">
          This will be displayed when browsing for channels.
        </p>
      </Flex>
    </Modal>
  );
};

export default CreateChannelModal;